import { gql } from "@apollo/client/core";
import { getGraphqlClient } from "./graphql";
import { ApolloClient } from "@apollo/client";

interface Session {
  id: string;
  userId: string;
  sessionId: string;
  siteId?: string;
  lastActivityDate?: string;
}
type NewSessionHandler = (session: Session) => void;
interface UserLockInitConfig {
  userId: string;
  siteId?: string;
  accessKeyId: string;
  secretAccessKey: string;
  metadata?: object;
  onNewSession?: NewSessionHandler;
}
export default function userLockInit(config: UserLockInitConfig) {
  const client = getGraphqlClient({
    accessKeyId: config.accessKeyId,
    secretAccessKey: config.secretAccessKey,
  });
  let sessionId = localStorage.getItem("user-lock-sessionId");
  if (!sessionId) {
    sessionId = Math.random().toString(36);
    localStorage.setItem("user-lock-sessionId", sessionId);
  }
  setSession(client, config.userId, config.siteId, sessionId, config.metadata);
  startSubscription(
    client,
    config.userId,
    config.siteId,
    sessionId,
    config.onNewSession
  );
}

(global as any).userLockInit = userLockInit;

async function startSubscription(
  client: ApolloClient<any>,
  userId: string,
  siteId: string,
  sessionId: string,
  newSessionHandler?: NewSessionHandler
) {
  try {
    const subscription = client.subscribe<{ onSetUserSession: Session }>({
      query: gql`
        subscription onSetUserSession($userId: ID!, $siteId: ID!) {
          onSetUserSession(userId: $userId, siteId: $siteId) {
            userId
            sessionId
            siteId
            metadata
            lastActivityDate
          }
        }
      `,
      variables: {
        userId,
        siteId,
      },
    });
    subscription.subscribe({
      next: (val) => {
        if (
          newSessionHandler &&
          val.data.onSetUserSession.sessionId !== sessionId
        ) {
          newSessionHandler(val.data?.onSetUserSession);
        }
      },
    });
    console.log("initialized user subscription", {
      userId,
      siteId,
    });
  } catch (err) {
    console.log("failed to start subscription", err);
  }
}
async function setSession(
  client: ApolloClient<any>,
  userId: string,
  siteId: string,
  sessionId: string,
  metadata?: object
) {
  try {
    const res = await client.mutate({
      mutation: gql`
        mutation setSession(
          $userId: ID!
          $siteId: ID!
          $sessionId: ID!
          $metadata: AWSJSON
        ) {
          setUserSession(
            userId: $userId
            siteId: $siteId
            sessionId: $sessionId
            metadata: $metadata
          ) {
            userId
            siteId
            sessionId
            metadata
            lastActivityDate
          }
        }
      `,
      variables: { userId, siteId, sessionId, metadata },
    });
    console.log("initialized user session", res);
  } catch (err) {
    console.log("failed to initialize user session", err);
  }
}
